import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeTextBaseComponent } from './e5core-ui-work-field-type-text-base';

@Component({
  selector: 'e5core-ui-work-field-type-text-box',
  templateUrl: './e5core-ui-work-field-type-text-box.component.html',
  styleUrls: ['./e5core-ui-work-field-type-text-box.component.css']
})
export class E5coreUiWorkFieldTypeTextBoxComponent extends E5coreUiWorkFieldTypeTextBaseComponent {
}
